<template>
  <vv-screen-wrapper>
    <div class="screen-container">
      <vv-box :title="$t('tasting.section.summary.result')">
        <div class="summary-intro">{{ $t(`tasting.section.${sectionId}.summary_intro`) }}</div>

        <div class="questions">
          <div class="question" v-for="question in questions" :key="question.id">
            <summary-answer :question="question" />
          </div>
        </div>
      </vv-box>
      <div class="cta">
        <vv-button @click="nextSection" id="'next'">{{
          $t('tasting.section.summary.button')
        }}</vv-button>
      </div>
    </div>
  </vv-screen-wrapper>
</template>

<script>
import { mapGetters } from 'vuex'

import { VvBox, VvButton, VvScreenWrapper } from '@/components/common'
import SummaryAnswer from '@/components/tasting/SummaryAnswer'

import { NEXT_SECTION } from '@/store/modules/tasting/types'

export default {
  name: 'SectionSummary',
  components: { VvBox, VvButton, SummaryAnswer, VvScreenWrapper },
  computed: {
    ...mapGetters({ questions: 'currentQuestionListForSection' }),
    sectionId() {
      return this.$router.currentRoute.params.sectionId
    }
  },
  mounted() {
    if (this.questions && this.questions.length <= 0) {
      this.nextSection()
    }
  },
  methods: {
    nextSection() {
      this.$store.dispatch(NEXT_SECTION)
    }
  }
}
</script>

<style scoped>
.questions {
  margin-top: 30px;
}
</style>
